/* NoliX theme — small progressive enhancements (no dependencies) */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    main.srcset = '';
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  // Variant selection -> update hidden id, price and button state
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var selects = form.querySelectorAll('[data-option]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var button = form.querySelector('[data-add]');
    var buyBtn = form.querySelector('[data-buy]');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) { button.disabled = true; button.textContent = button.getAttribute('data-unavailable'); if (buyBtn) buyBtn.disabled = true; return; }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      button.disabled = !match.available;
      if (buyBtn) buyBtn.disabled = !match.available;
      button.textContent = match.available ? button.getAttribute('data-add-label') : button.getAttribute('data-soldout');
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  // Trademark status filter
  document.querySelectorAll('[data-tm-filter]').forEach(function (bar) {
    var scope = bar.closest('section') || document;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var f = b.getAttribute('data-filter');
      bar.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      scope.querySelectorAll('[data-status]').forEach(function (card) {
        card.hidden = !(f === 'all' || card.getAttribute('data-status') === f);
      });
    });
  });
})();

// Product video popups (Industries page)
document.addEventListener('click', function (e) {
  var open = e.target.closest('[data-video-open]');
  if (open) {
    var dlg = document.getElementById(open.getAttribute('data-video-open'));
    if (!dlg) return;
    var frame = dlg.querySelector('iframe[data-src]');
    if (frame) frame.src = frame.getAttribute('data-src');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var v = dlg.querySelector('video'); if (v) { try { v.play(); } catch (err) {} }
    return;
  }
  var dlgEl = e.target.closest('dialog.video-modal');
  if (e.target.closest('[data-video-close]') || (dlgEl && e.target === dlgEl)) { dlgEl.close ? dlgEl.close() : dlgEl.removeAttribute('open'); }
});
document.querySelectorAll('dialog.video-modal').forEach(function (dlg) {
  dlg.addEventListener('close', function () {
    var v = dlg.querySelector('video'); if (v) v.pause();
    var f = dlg.querySelector('iframe'); if (f) f.removeAttribute('src');
  });
});

// Video gallery filter
document.querySelectorAll('[data-video-filter]').forEach(function (bar) {
  var grid = bar.parentElement.querySelector('.video-grid');
  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-filter]');
    if (!btn) return;
    bar.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    var f = btn.getAttribute('data-filter');
    grid.querySelectorAll('.video-card').forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-cat') !== f; });
  });
});
